import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getInvitations, updateInvitation } from 'Services/user';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvitations() {
    const queryClient = useQueryClient();
    const { data, isLoading } = useQuery({
        queryKey: ['invitations'],
        queryFn: getInvitations,
        onError: trackError,
    });

    const acceptInvitation = async (projectId) => {
        await updateInvitation(projectId, { action: 'accept' });
        // Accepting switches the user to the invited project, so every query has to be refetched
        await queryClient.invalidateQueries();
    };

    const rejectInvitation = async (projectId) => {
        await updateInvitation(projectId, { action: 'reject' });
        await queryClient.invalidateQueries({ queryKey: ['invitations'] });
    };

    return {
        invitations: data ?? [],
        isLoading,
        acceptInvitation,
        rejectInvitation,
    };
}
